import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import ListOfRepairService from '../services/ListOfRepairService';

export const fetchRepairsIot = createAsyncThunk(
  'repairsIot/fetchRepairsIot',
  async ({ projectName, companyName }, { rejectWithValue }) => { // ← เพิ่ม companyName
    try {
      const data = await ListOfRepairService.getListOfRepairsIot(projectName, companyName); // ← ส่ง companyName
      console.log('Fetched repairs iot:', data);
      return data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

const repairIotSlice = createSlice({
  name: 'repairsIot',
  initialState: { data: [], loading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRepairsIot.pending, (state) => { state.loading = true; })
      .addCase(fetchRepairsIot.fulfilled, (state, action) => { state.loading = false; state.data = action.payload; })
      .addCase(fetchRepairsIot.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export default repairIotSlice.reducer;